import './ContentBuilderTemplate.scss';
import './ContentBuilderTemplate72.scss';

import React from 'react';
import { cn } from '@bem-react/classname';
import { cnContentBuilderTemplate } from './index';
import { Typography } from '@dataartdev/uikit/Typography';
import { Grid, GridItem } from '@dataartdev/uikit/Grid';
import { Button } from '@dataartdev/uikit/Button';
import { IconArrowRight } from '@dataartdev/uikit/IconArrowRight';
import { IRoot72 } from './models/CTI_72.props';
import { prepareButtonAttrs } from '../../../utils/prepareButtonAttrs';

const cnDiagram = cn('Diagram');

export const ContentBuilderTemplate: React.FC<IRoot72> = props => {
  const { type, title, text, link, items, contentId } = props || {};

  const { link: buttonLink, title: buttonTitle, targetBlank = false } =
    link || {};

  const typeNumber = type?.toString();

  return (
    <div
      className={cnContentBuilderTemplate({ type: typeNumber })}
      id={contentId}
    >
      <Grid breakpoints={{ desktop: { cols: 12 } }}>
        {(title || text) && (
          <GridItem
            breakpoints={{
              desktop: { col: 8 },
              tablet: { col: 12 },
              mobile: { col: 12 },
            }}
          >
            {title && (
              <Typography.Title size="lg" as="h2" parse>
                {title}
              </Typography.Title>
            )}
            {text && (
              <Typography.Text
                className={cnDiagram('Description')}
                as="p"
                size="m"
                parse
              >
                {text}
              </Typography.Text>
            )}
          </GridItem>
        )}
        <GridItem
          className={cnDiagram('Scheme')}
          breakpoints={{
            desktop: { col: 12 },
            tablet: { col: 12 },
            mobile: { col: 12 },
          }}
        >
          {items && items.length > 0 && (
            <div className={cnDiagram('Scheme-Inner')}>
              {items.map(item => {
                const {
                  title,
                  height = 200,
                  icon,
                  color = 'f15046',
                  subtitle,
                  isInverted,
                } = item || {};
                return (
                  <div
                    className={cnDiagram('Scheme-Section', {
                      isInverted: isInverted,
                    })}
                    key={item?.id}
                  >
                    <div
                      className={cnDiagram('Scheme-Bar')}
                      style={{ backgroundColor: color, height: `${height}px` }}
                    >
                      {icon && (
                        <img
                          src={icon?.urlWebp || icon?.url}
                          className={cnDiagram('Icon')}
                          alt={icon?.alt}
                        />
                      )}
                      {title && (
                        <Typography.Text
                          as="span"
                          size="m"
                          weight="bold"
                          className={cnDiagram('Scheme-Title')}
                        >
                          {title}
                        </Typography.Text>
                      )}
                      {subtitle && (
                        <Typography.Text
                          as="span"
                          size="m"
                          className={cnDiagram('Scheme-Text')}
                        >
                          {subtitle}
                        </Typography.Text>
                      )}
                    </div>
                    <div className={cnDiagram('Bottom')}>
                      <div
                        className={cnDiagram('Scheme-Dot')}
                        style={{ backgroundColor: color }}
                      />
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </GridItem>
        {link && (
          <GridItem
            className={cnDiagram('Cta')}
            breakpoints={{
              desktop: { col: 12 },
              tablet: { col: 12 },
              mobile: { col: 12 },
            }}
          >
            {buttonLink && buttonTitle && (
              <Button
                {...prepareButtonAttrs(buttonLink, buttonTitle, targetBlank)}
                view="primary"
                iconRight={IconArrowRight}
                label={'Learn more'}
                align="center"
              />
            )}
          </GridItem>
        )}
      </Grid>
    </div>
  );
};

export default ContentBuilderTemplate;
